/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeAblyRpc
 */

export const getAblyTokenRequestRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeAblyRpc',
  rpcName: 'getAblyTokenRequest',
  auth: 'app',
  fingerprint: 'hjHY7VhYgKtETNRZE1TryzCO8C2ISrp_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getStrategyChannelIdRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeAblyRpc',
  rpcName: 'getStrategyChannelId',
  auth: 'app',
  fingerprint: '1a5G4RUkaJZx-J6uwjFIUjCO8C2ISrp_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};